import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Network } from 'lucide-react';
import { qrGet, qrPatch } from './qrApi';
import { Button } from '@/components/ui/button';

/** Track0tic admin: per-tenant portal IP policy (CIDR allowlist + enforcement). Tenant sees it read-only. */
export function TenantIpPolicyCard({ tenantId }) {
  const [p, setP] = useState(null);
  const [cidrs, setCidrs] = useState('');
  const [enforced, setEnforced] = useState(false);
  const load = useCallback(() => qrGet(`/tenants/${tenantId}/ip-policy`).then(r => { setP(r); setCidrs(r.allowed_ips.join('\n')); setEnforced(r.enforced); }).catch(e => toast.error(e.message)), [tenantId]);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    try { await qrPatch(`/tenants/${tenantId}/ip-policy`, { enforced, allowed_ips: cidrs.split(/\s+/).filter(Boolean) }); toast.success('IP policy saved'); load(); }
    catch (e) { toast.error(e.message); }
  };
  if (!p) return null;
  return (
    <div className="rounded-lg border bg-white p-5 mt-6" style={{ borderColor: '#E5E3DC' }} data-testid="tenant-ip-policy">
      <h3 className="font-bold flex items-center gap-2 mb-1"><Network size={16} /> Portal IP policy <span className="text-xs font-normal" style={{ color: '#6b7069' }}>pod: {p.pod} · {p.denials_24h} blocked in 24 h</span></h3>
      <p className="text-xs mb-3" style={{ color: '#6b7069' }}>CIDRs only (e.g. 203.0.113.0/24). Applies to office portal routes; field actions (bind, handover, device/passport pages, OTP login) are never blocked.</p>
      <textarea data-testid="ip-policy-cidrs" value={cidrs} onChange={e => setCidrs(e.target.value)} rows={4} className="w-full rounded border p-2 text-sm font-mono bg-white" style={{ borderColor: '#D9D6CD' }} placeholder="203.0.113.0/24&#10;198.51.100.7/32" />
      <label className="flex items-center gap-2 text-sm mt-2"><input type="checkbox" data-testid="ip-policy-enforced" checked={enforced} onChange={e => setEnforced(e.target.checked)} /> Enforce for this customer's portal users</label>
      <Button data-testid="ip-policy-save" size="sm" className="h-8 mt-3 text-white" style={{ background: '#0B6B55' }} onClick={save}>Save policy</Button>
    </div>
  );
}
